/* ft-kopf.js (05.10.2026, Sitzung Webshop, Auftrag der Teamleitung „Ladezeit des Kopfes“):
   Skript der Kopfzeile (Suche mit Vorschlägen, Handy-Menü, Mega-Menü mit Bildern und Kacheln), vorher rund 47 KB inline in
   jeder Seite. Läuft jetzt mit defer nach dem Aufbau der Seite und kommt beim zweiten Seitenaufruf aus dem Zwischenspeicher.
   Die Mega-Menüs sind beim Aufbau unsichtbar, die Suche und das Handy-Menü öffnen erst auf Klick, deshalb ändert defer am
   ersten Bild nichts. Weiter inline in sections/ft-header.liquid: Bilder-Adressen aus Liquid (window.ftKopfBilder),
   Symbole der Menüleiste (vor dem ersten Bild), HSN-Regel (window.ftHsnNorm) und Warenkorb-Zähler ohne Pfand. */
(function() {
  /* ── Sticky-Header: schwarze TopBar beim Scrollen einklappen (kompaktere Höhe) ────
     Hysterese (einklappen >120px, ausklappen <40px) + rAF-Entprellung verhindern
     das Flackern: ein einzelner Schwellwert wuerde nahe der Grenze oszillieren, weil
     das Einklappen die Seitenhoehe aendert und die Scroll-Position zurueckspringt. */
  var ftHeader = document.querySelector('.ft-header');
  if (ftHeader) {
    var ftCollapsed = false, ftTick = false;
    var ftApply = function() {
      ftTick = false;
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      if (!ftCollapsed && y > 120) { ftCollapsed = true; ftHeader.classList.add('ft-scrolled'); }
      else if (ftCollapsed && y < 40) { ftCollapsed = false; ftHeader.classList.remove('ft-scrolled'); }
    };
    var ftOnScroll = function() {
      if (!ftTick) { ftTick = true; window.requestAnimationFrame(ftApply); }
    };
    window.addEventListener('scroll', ftOnScroll, { passive: true });
    ftApply();
  }

  /* ── Mobile Hamburger Drawer ───────────────────────── */
  var burgerBtn = document.getElementById('ft-burger-open');
  var drawer = document.getElementById('ft-drawer');
  if (burgerBtn && drawer) {
    var burgerOpen = function() {
      drawer.hidden = false;
      burgerBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function() { drawer.classList.add('is-open'); });
    };
    var burgerClose = function() {
      drawer.classList.remove('is-open');
      burgerBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(function() { drawer.hidden = true; }, 260);
    };
    burgerBtn.addEventListener('click', burgerOpen);
    drawer.querySelectorAll('[data-ft-drawer-close]').forEach(function(el) {
      el.addEventListener('click', burgerClose);
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !drawer.hidden) burgerClose();
    });
  }

  /* ── Search Overlay (Cmd+K) ────────────────────────── */
  var overlay = document.getElementById('ft-search-overlay');
  var openers = document.querySelectorAll('#ft-search-open, [data-ft-search-open]');
  var input = document.getElementById('ft-search-input');

  function openSearch() {
    overlay.hidden = false;
    /* 16.10.2026: „Fahrzeug wählen“ aus dem Handy-Menü setzt data-ohne-fokus, dann bleibt die Tastatur zu */
    if (overlay.hasAttribute('data-ohne-fokus')) { overlay.removeAttribute('data-ohne-fokus'); return; }
    setTimeout(function() { input && input.focus(); }, 30);
  }
  function closeSearch() {
    overlay.hidden = true;
    var box = document.getElementById('ft-search-suggestions');
    if (box) { box.hidden = true; box.innerHTML = ''; }
    if (input) input.value = '';
  }

  /* 14.10.2026: Die Lupe am Handy ist ein Link zur Suchseite (ohne Skript), mit Skript öffnet sie das Suchfenster */
  openers.forEach(function(el) { el.addEventListener('click', function(e) { e.preventDefault(); openSearch(); }); });
  overlay.querySelectorAll('[data-ft-search-close]').forEach(function(el) {
    el.addEventListener('click', closeSearch);
  });

  document.addEventListener('keydown', function(e) {
    if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
      e.preventDefault();
      if (overlay.hidden) openSearch(); else closeSearch();
    }
    if (e.key === 'Escape' && !overlay.hidden) closeSearch();
  });

  /* ── Search Autocomplete (Live-Suggestions) ─────────── */
  var suggestionsBox = document.getElementById('ft-search-suggestions');
  var searchForm = overlay.querySelector('.ft-search-overlay-form');
  /* 16.10.2026 nachts: grüner Suchknopf bei leerem Feld führt nicht auf eine leere Trefferseite, sondern zurück ins Feld */
  if (searchForm) searchForm.addEventListener('submit', function (e) { if (input && !input.value.trim()) { e.preventDefault(); input.focus(); } });
  var debounceTimer = null;
  var activeIndex = -1;
  var lastQuery = '';
  var currentController = null;

  /* v0.39: Zustands-Label für Suchvorschläge — NUR für Turbolader.
     Montagesätze/Dichtungen/Ölleitungen/Zubehör tragen keinen
     Aufbereitungszustand und dürfen NIE als "Generalüberholt" erscheinen.
     Quelle ist der Produkttitel (Pascals Konvention: Zustand steht im Titel).
     24.07.: bleibt der Fallback — vorrangig gilt jetzt ein geliefertes
     Feld, siehe ftCondFor weiter unten. */
  /* Review-Fix 24.07.: Liste auf denselben Stand gebracht wie die
     Produktkarte (ft-product-card.liquid, zub_wort: montagesatz, dichtung,
     LEITUNG, sensor, aktuator, schlauch, chra/rumpfgruppe). Vorher fehlten
     hier „leitung" (die Artikel heißen „Öl-/Wasserleitung" — das enthält
     weder „ölleitung" noch „oelleitung"), „sensor", „aktuator" und
     „rumpfgruppe". Belegt in den Bestandsdaten: Handles wie
     oel-wasserleitung-oe-a6111800720 tragen den Variantenwert
     „Generalüberholt". Sobald search.json.liquid ein condition-Feld
     liefert, hätte die Live-Suche diesen Zustand auf einer Leitung
     ausgegeben — Karte zeigt dort keinen. Genau QA-Blocker 3. */
  var FT_ZUBEHOER_RE = /(montagesatz|anbausatz|dichtung|leitung|sensor|aktuator|chra|rumpfgruppe|zubehör|zubehoer|schlauch|schelle|hitzeschutz|stehbolzen)/;
  function ftIstZubehoer(title) {
    return FT_ZUBEHOER_RE.test(String(title || '').toLowerCase());
  }
  function ftCondLabel(title) {
    var t = String(title || '').toLowerCase();
    if (ftIstZubehoer(t)) return '';
    if (t.indexOf('turbolader') === -1) return '';
    if (t.indexOf('generalüberholt') >= 0 || t.indexOf('generalueberholt') >= 0) return 'Generalüberholt';
    if (/(^|[\s(·])neu([\s),.·]|$)/.test(t)) return 'Neu';
    return '';
  }

  /* 24.07. — Zustand jetzt ZWEISTUFIG (Pascal: „gerne auch mehr infos
     rausgeben bei der live suche und dessen ergebnisse"):
     1. ein vom JSON geliefertes Feld (condition/zustand) schlägt alles —
        das ist ein Datum, keine Ableitung. Erlaubt sind aber NUR die zwei
        bekannten Werte; alles andere ("Gebraucht", "Refurbished", leer)
        ergibt KEINEN Chip statt einer falschen Behauptung.
     2. fehlt das Feld (Stand heute liefert templates/search.json.liquid
        es nicht), greift die alte Titel-Heuristik ftCondLabel.
     In BEIDEN Fällen gilt die Zubehör-Sperre: Montagesätze, Dichtungen,
     Leitungen usw. tragen keinen Aufbereitungszustand und dürfen nie als
     „Generalüberholt" erscheinen (QA-Blocker 3 der Produktkarte). */
  function ftCondFor(p) {
    if (!p || ftIstZubehoer(p.title)) return '';
    var raw = p.condition || p.zustand;
    if (raw) {
      var t = String(raw).split('·')[0].trim().toLowerCase();
      if (t === 'neu' || t === 'original neu') return 'Neu';
      if (t === 'generalüberholt' || t === 'generalueberholt') return 'Generalüberholt';
      return '';
    }
    return ftCondLabel(p.title);
  }

  /* Altteilpfand — rein defensiv: templates/search.json.liquid liefert das
     Feld heute NICHT (die Datei gehört dem Hero-Agenten, hier wird sie nur
     gelesen). Kommt eines der Felder dazu, erscheint die Zeile automatisch;
     fehlt es, bleibt sie sauber weg. Erwartet wird — wie beim price-Feld —
     ein EURO-Betrag, kein Cent-Wert. */
  function ftPfandBetrag(p) {
    if (!p) return 0;
    var raw = p.pfand;
    if (raw === undefined || raw === null || raw === '') raw = p.pfand_value;
    if (raw === undefined || raw === null || raw === '') return 0;
    var n;
    if (typeof raw === 'number') {
      n = raw;
    } else {
      /* Review-Fix 24.07.: deutsche Schreibweise sicher lesen. Ein simples
         replace(',', '.') hätte aus „1.234,56" den Wert 1.234 gemacht —
         also einen FALSCHEN Pfandbetrag angezeigt. Enthält der String ein
         Komma, ist der Punkt der Tausendertrenner und muss weg; ohne Komma
         bleibt der Punkt das Dezimalzeichen („119.00"). */
      var s = String(raw).trim().replace(/[\s €]/g, '');
      if (s.indexOf(',') >= 0) s = s.replace(/\./g, '').replace(',', '.');
      n = parseFloat(s);
    }
    if (isNaN(n) || n <= 0) return 0;
    return n;
  }

  /* 14.10.2026 abends (Recherche der Teamleitung, Regel c9: dieselbe Rangfolge in Liste, Tippvorschlag und Kategorie, wie
     snippets/ft-such-rang): Lader zuerst, dann Komplettsets und Sets, Rumpfgruppe, Stellmotor, Montagesatz, Leitungen, Schläuche,
     Sensoren und AGR; innerhalb einer Art bleibt die Reihenfolge von Shopify. Nennt die Eingabe eine Art („agr 03l“), bleibt alles. */
  var FT_ARTWORT = /(agr|sensor|sensoren|nox|montagesatz|montagesaetze|montagesätze|dichtung|leitung|leitungen|oelleitung|ölleitung|schlauch|ladeluftschlauch|aktuator|stellmotor|druckdose|rumpfgruppe|chra|krümmer|kruemmer|abgasklappe|dpf|kupplung|thermostat|set|komplettset)/i;
  var FT_ARTRANG = [[/^turbolader-(komplettset|set)(-|$)/, 1], [/^rumpfgruppe/, 2], [/^(vtg-aktuator|turbolader-stellmotor|stellmotor|druckdose)/, 3],
    [/^(turbolader-)?montagesatz/, 4], [/^(oel-wasserleitung|l-wasserleitung|oelleitung)/, 5], [/^(ladeluftschlauch|kuehlerschlauch|ansaugschlauch)/, 6],
    [/^(sensor|nox-sensor|abgastemperatursensor|agr-|kuehler-agr)/, 7], [/^turbolader(-|$)/, 0]];
  function ftArtRang(p) {
    var m = String((p && p.url) || '').split('?')[0].match(/\/products\/([^\/#]+)/);
    if (!m) return 8;
    var h = decodeURIComponent(m[1]);
    for (var i = 0; i < FT_ARTRANG.length; i++) if (FT_ARTRANG[i][0].test(h)) return FT_ARTRANG[i][1];
    return 8;
  }
  function renderSuggestions(items, query) {
    activeIndex = -1;
    if (items && items.length > 1 && !FT_ARTWORT.test(query || '')) {
      items = items.map(function(p, i) { return { p: p, i: i, r: ftArtRang(p) }; })
        .sort(function(a, b) { return (a.r - b.r) || (a.i - b.i); }).map(function(x) { return x.p; });
    }
    if (!items || items.length === 0) {
      if (query && query.length >= 2) {
        /* 31.07.2026 (Prüfplan Nr. 8): „Kein Treffer" war eine Sackgasse im Moment
           höchster Kaufabsicht — dabei kennt die Suchseite über den Nummern-Index
           54.000 Nummern, die die Live-Vorschau nicht kennt. Statt Abbruch: ein
           Knopf, der die volle Suche auslöst. */
        /* 13.08.2026: Der Knopf war TOT — #ft-search-suggestions steht als
           Geschwister NACH dem </form>, this.closest('form') fand nie etwas,
           der Klick tat nichts (Sackgasse im Moment hoechster Kaufabsicht).
           Jetzt submittet er ueber das form-Attribut (Knopf darf ausserhalb
           des Formulars stehen), kein Inline-JS mehr noetig. */
        suggestionsBox.innerHTML = '<div class="ft-search-suggestions-empty">Keine Sofort-Vorschau für <strong>' + escapeHtml(query) + '</strong>.'
          + '<button type="submit" form="ft-search-overlay-form" class="ft-search-suggestions-voll">'
          + 'In allen 54.000 Nummern suchen</button></div>';
        suggestionsBox.hidden = false;
      } else {
        suggestionsBox.hidden = true;
        suggestionsBox.innerHTML = '';
      }
      return;
    }
    var html = items.map(function(p, i) {
      var img = p.image ? (p.image.indexOf('http') === 0 ? p.image : 'https:' + p.image) : null;
      var price = p.price ? formatPrice(p.price) : '';
      var vendor = window.ftMfg ? window.ftMfg(p.vendor) : (p.vendor || '');
      /* v0.39: Herstellernamen nie doppeln — beginnt der Titel bereits mit
         dem Hersteller ("Mitsubishi 49135-…"), entfällt die Vendor-Zeile.
         Vorher las sich der Vorschlag als "Mitsubishi Mitsubishi …". */
      /* 08.10.2026: Name wie auf der Produktkarte (Feld „name“ aus templates/search.json.liquid), sonst der Titel. */
      var nameTxt = p.name || String(p.title || '').split(' | ')[0];
      if (vendor) {
        var vNorm = vendor.toLowerCase().replace(/[-. ]/g, '');
        var tNorm = String(nameTxt).toLowerCase().replace(/[-. ]/g, '');
        if (vNorm && tNorm.indexOf(vNorm) === 0) vendor = '';
      }
      var cond = ftCondFor(p);
      /* Verfügbarkeit nur zeigen, wenn sie WIRKLICH in der Antwort steht.
         Ein fehlendes Feld (undefined) ist keine Aussage — dann bleibt die
         Ampel weg, statt „Nicht auf Lager" zu behaupten. */
      var avail = (p.available === true || p.available === false) ? p.available : null;
      var pfand = ftPfandBetrag(p);
      var pfandTxt = pfand > 0 ? 'zzgl. ' + Math.round(pfand) + ' € Altteilpfand' : ''; /* 02.10.2026: ganze Euro wie überall */
      var meta = '';
      if (cond) {
        meta += '<span class="ft-search-suggestion-cond ' + (cond === 'Neu' ? 'is-neu' : 'is-reman') + '">' + cond + '</span>';
      }
      /* 16.10.2026 nachts: Lieferwagen bzw. Uhr statt farbigem Punkt und dieselben Worte wie die Produktkarte (Pascal: keine Punkte als Status) */
      if (avail === true) {
        meta += '<span class="ft-search-suggestion-stock"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v10H3z"/><path d="M14 9h4l3 3v4h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>Auf Lager</span>';
      } else if (avail === false) {
        meta += '<span class="ft-search-suggestion-stock is-out"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>Zurzeit nicht auf Lager</span>';
      }
      var u = (p.url || '') + ((p.url || '').indexOf('?') >= 0 ? '&' : '?') + '_fd=0';
      return (
        '<a href="' + escapeHtml(u) + '" class="ft-search-suggestion" role="option" data-idx="' + i + '">' +
        /* Lazy-0x0-Falle: width/height-Attribute UND feste CSS-Maße
           (.ft-search-suggestion-img 48×48) — sonst misst der Browser das
           lazy geladene Bild mit 0×0 und die Zeile springt beim Nachladen. */
        (img
          ? '<img class="ft-search-suggestion-img" src="' + escapeHtml(img) + '" alt="" width="48" height="48" loading="lazy">'
          : '<div class="ft-search-suggestion-img"></div>') +
        '<div class="ft-search-suggestion-body">' +
          (vendor ? '<div class="ft-search-suggestion-vendor">' + escapeHtml(vendor) + '</div>' : '') +
          '<div class="ft-search-suggestion-title">' + escapeHtml(nameTxt) + '</div>' +
          (meta ? '<div class="ft-search-suggestion-meta">' + meta + '</div>' : '') +
        '</div>' +
        (price || pfandTxt
          ? '<div class="ft-search-suggestion-pricecol">' +
              (price && window.ftUvpPlatz ? window.ftUvpPlatz(p.handle || window.ftUvpHandle(p.url)) : '') +
              (price ? '<div class="ft-search-suggestion-price">' + price + '</div>' : '') +
              (pfandTxt ? '<div class="ft-search-suggestion-pfand">' + pfandTxt + '</div>' : '') +
            '</div>'
          : '') +
        '</a>'
      );
    }).join('');
    suggestionsBox.innerHTML = html;
    suggestionsBox.hidden = false;
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function(c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  /* Review-Fix 22.07.: de-DE-Format mit Tausenderpunkt („1.683,64 €") —
     „€1683,64" war der von Pascal beanstandete Fehler (siehe
     ft-recently-viewed). Gleiche Optik wie im Zuletzt-angesehen-Slider. */
  var ftEurFormat = null;
  try {
    ftEurFormat = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  } catch (e) {}
  function formatPrice(price) {
    // /search?view=json returns decimal strings like "511.61", not cents
    var n = typeof price === 'number' ? price : parseFloat(price);
    if (isNaN(n)) return '';
    if (ftEurFormat) return ftEurFormat.format(n);
    return n.toFixed(2).replace('.', ',') + ' €';
  }

  /* 21.07 Abnahme (Blocker 1): Nummern-Eingaben mit Bindestrich/Punkt/
     Leerzeichen liefern sonst 0 Vorschläge — für den Fetch dieselbe
     Normalisierung wie die Suchseite (>=6 alphanumerisch, >=40% Ziffern).
     Nur die Fetch-Query wird umgeschrieben, die Anzeige-Eingabe im Feld
     bleibt unangetastet. */
  function ftNormNumQuery(q) {
    if (!/[-–.\s]/.test(q)) return q;
    var alnum = q.replace(/[^0-9A-Za-z]/g, '');
    if (alnum.length < 6) return q;
    var digits = alnum.replace(/[^0-9]/g, '');
    if (digits.length / alnum.length < 0.4) return q;
    return q.replace(/[-–.\s]/g, '');
  }

  function fetchSuggestions(q) {
    if (currentController) try { currentController.abort(); } catch (e) {}
    if (typeof AbortController !== 'undefined') currentController = new AbortController();
    var signal = currentController ? currentController.signal : undefined;
    // Volltext-Suche (findet OE-/Teilenummern aus der Beschreibung) statt eingeschränkter Vorschlags-API
    // 23.07. (2): Erst ROH suchen — Artikelnummern wie "TLMS-0006" wurden
    // vom Separator-Stripping zerstört ("TLMS0006" = 0 Treffer, SKU-Suche
    // braucht den Bindestrich). Nur bei 0 Treffern normalisiert nachfassen
    // ("5303 988 0290" -> "53039880290"). Außerdem: /search?view=json
    // liefert jetzt {count,items} — beide Formate lesen (vorher flog das
    // Objekt ungeparst in items.map -> TypeError -> Dropdown blieb stumm).
    var mkUrl = function(term) { return '/search?q=' + encodeURIComponent(term) + '&type=product&options[prefix]=last&view=json&_fd=0'; };
    var parseItems = function(txt) { var d = null; try { d = JSON.parse(txt); } catch (e) { return []; } if (Array.isArray(d)) { return d; } return (d && d.items) || []; };
    suggestionsBox.innerHTML = '<div class="ft-search-suggestions-loading">Suche läuft…</div>';
    suggestionsBox.hidden = false;
    var norm = ftNormNumQuery(q);
    /* Review-Fix 24.07.: HSN/TSN mit Schrägstrich („0588/638", „0588/AMD" —
       genau die Schreibweise aus dem Fahrzeugschein) kam im Dropdown als
       „Kein Treffer" zurück, während dieselbe Eingabe mit Enter 6 Treffer
       lieferte: ftNormNumQuery kennt nur [-–. Leerzeichen] als Trenner,
       der Schrägstrich fehlte. Deshalb hier dieselbe Normalisierung wie
       beim Absenden (ftHsnNorm, weiter unten in eigener IIFE). Betrifft
       NUR die Nachfass-Query — die ROH-Suche bleibt unangetastet, damit
       SKUs wie „TLMS-0006" weiter ihren Bindestrich behalten.
       Fallback-Kette: fehlt die Funktion oder liefert sie null (jede
       Nicht-HSN-Eingabe), bleibt es beim bisherigen ftNormNumQuery-Wert. */
    var ftHsnTag = (typeof window.ftHsnNorm === 'function') ? window.ftHsnNorm(q) : null;
    if (ftHsnTag) norm = ftHsnTag;
    fetch(mkUrl(q), { signal: signal, credentials: 'same-origin' })
      .then(function(r) { return r.text(); })
      .then(function(txt) {
        if (q !== lastQuery) return;
        var products = parseItems(txt);
        if (!products.length && norm !== q) {
          return fetch(mkUrl(norm), { signal: signal, credentials: 'same-origin' })
            .then(function(r2) { return r2.text(); })
            .then(function(t2) {
              if (q !== lastQuery) return;
              renderSuggestions(parseItems(t2), q);
            });
        }
        renderSuggestions(products, q);
      })
      .catch(function(err) {
        if (err && err.name === 'AbortError') return;
        suggestionsBox.hidden = true;
      });
  }

  function onInput() {
    var q = (input.value || '').trim();
    lastQuery = q;
    clearTimeout(debounceTimer);
    if (q.length < 2) {
      suggestionsBox.hidden = true;
      suggestionsBox.innerHTML = '';
      return;
    }
    debounceTimer = setTimeout(function() { fetchSuggestions(q); }, 180);
  }

  if (input) {
    input.addEventListener('input', onInput);
    input.addEventListener('keydown', function(e) {
      var items = suggestionsBox.querySelectorAll('.ft-search-suggestion');
      if (!items.length) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        activeIndex = Math.min(activeIndex + 1, items.length - 1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex = Math.max(activeIndex - 1, 0);
      } else if (e.key === 'Enter' && activeIndex >= 0) {
        e.preventDefault();
        items[activeIndex].click();
        return;
      } else {
        return;
      }
      items.forEach(function(el, i) {
        el.classList.toggle('is-active', i === activeIndex);
      });
      items[activeIndex].scrollIntoView({ block: 'nearest' });
    });
  }

  /* ── Mega-Menu Click-Toggle (für Touch-Devices) ─────── */
  var catnavItems = document.querySelectorAll('.ft-catnav-item');
  var hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  /* 22.07. (Pascal): Es darf immer nur EIN Mega-Menü offen sein.
     Die 400ms-Schließtoleranz (CSS oben) ließ beim Wandern über mehrere
     Trigger zwei Panels gleichzeitig sichtbar werden. Fix: beim Öffnen
     eines Triggers (Hover/Fokus/Touch-Tap) alle anderen Items sofort
     zwangsschließen — über die bestehende is-esc-closed-Klasse
     (fair-turbo.css: opacity/visibility !important, transition none).
     pointerenter/focusin/Tap räumen die Klasse am eigenen Item ab. */
  function ftMegaLink(item) {
    return item.querySelector('.ft-catnav-link[aria-haspopup="true"]');
  }
  function ftForceClose(item) {
    var l = ftMegaLink(item);
    if (l) l.setAttribute('aria-expanded', 'false');
    item.classList.add('is-esc-closed');
  }
  function ftCloseOthers(current) {
    catnavItems.forEach(function(other) {
      if (other !== current) ftForceClose(other);
    });
  }

  /* 21.07 Abnahme (Blocker 7): aria-expanded soll den sichtbaren
     Hover-/Fokus-Zustand spiegeln. Touch-Pointer bleiben ausgenommen,
     sonst würde der Click-Toggle unten beim ersten Tipp sofort navigieren
     (pointerenter/focusin feuern vor click). Rein additiv, CSS-Hover
     bleibt unangetastet. */
  var ftLastPointerType = '';
  document.addEventListener('pointerdown', function(e) { ftLastPointerType = e.pointerType || ''; }, true);
  var ftEscClosing = false;

  catnavItems.forEach(function(item) {
    var link = item.querySelector('.ft-catnav-link[aria-haspopup="true"]');
    var panel = item.querySelector('.ft-mega-panel');
    if (!link || !panel) return;

    link.setAttribute('aria-expanded', 'false');

    if (hasTouch) {
      link.addEventListener('click', function(e) {
        var isOpen = link.getAttribute('aria-expanded') === 'true';
        /* Nur ein Menü offen: alle anderen sofort zwangsschließen */
        ftCloseOthers(item);
        if (!isOpen) {
          e.preventDefault();
          item.classList.remove('is-esc-closed');
          link.setAttribute('aria-expanded', 'true');
        }
      });
    }

    /* Blocker 7: Hover/Fokus setzt aria-expanded, Escape schließt
       (Fokus zurück auf den Link; Flag verhindert, dass das dadurch
       ausgelöste focusin sofort wieder öffnet). */
    item.addEventListener('pointerenter', function(e) {
      if (e.pointerType === 'touch') return;
      item.classList.remove('is-esc-closed');
      ftCloseOthers(item);
      link.setAttribute('aria-expanded', 'true');
    });
    item.addEventListener('pointerleave', function(e) {
      if (e.pointerType === 'touch') return;
      link.setAttribute('aria-expanded', 'false');
    });
    item.addEventListener('focusin', function() {
      if (ftLastPointerType === 'touch' || ftEscClosing) return;
      item.classList.remove('is-esc-closed');
      ftCloseOthers(item);
      link.setAttribute('aria-expanded', 'true');
    });
    item.addEventListener('focusout', function(e) {
      if (e.relatedTarget && item.contains(e.relatedTarget)) return;
      link.setAttribute('aria-expanded', 'false');
    });
    item.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && link.getAttribute('aria-expanded') === 'true') {
        ftEscClosing = true;
        link.setAttribute('aria-expanded', 'false');
        /* Nachtest-FAIL 22.07.: aria alleine versteckt nichts — die
           Sichtbarkeit steuert CSS (:hover/:focus-within). Die Klasse
           erzwingt das Schließen; pointerenter räumt sie wieder ab. */
        item.classList.add('is-esc-closed');
        link.focus();
        setTimeout(function() { ftEscClosing = false; }, 0);
      }
    });
  });

  /* Nachtest-FAIL 22.07.: Escape muss auch im reinen HOVER-Fall schließen
     (ohne Fokus feuert das item-keydown nicht). */
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    catnavItems.forEach(function(item) {
      var l = item.querySelector('.ft-catnav-link[aria-haspopup="true"]');
      if (l && l.getAttribute('aria-expanded') === 'true') {
        l.setAttribute('aria-expanded', 'false');
        item.classList.add('is-esc-closed');
      }
    });
  });

  /* Close mega-menu when clicking outside — sofort, nicht erst nach
     der 400ms-Schließtoleranz (nur offene Items anfassen, damit nicht
     bei jedem Seitenklick Klassen gestreut werden). */
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.ft-catnav-item')) {
      catnavItems.forEach(function(item) {
        var l = ftMegaLink(item);
        if (l && l.getAttribute('aria-expanded') === 'true') ftForceClose(item);
      });
    }
  });

  /* ── Mega-Menü-Bilder: laden statt beim Seitenaufbau erst bei Bedarf
     (24.07., Ladezeit-Messung) ─────────────────────────────────────
     Ausgangslage: 18 Kachelfotos + 4 Feature-Bilder wurden EAGER geladen,
     obwohl das Panel erst beim Hover sichtbar wird — 22 Requests, die im
     ersten Bildschirm niemand sieht, und sie zählen ins load-Event.

     Warum loading="lazy" ALLEIN nicht reicht:
     Das Panel ist nicht display:none, sondern opacity:0 + visibility:hidden
     (fair-turbo.css) und liegt als absolut positionierter Kasten direkt
     unter der Navi — also mitten im sichtbaren Bereich. Der Browser prüft
     für lazy nur die Lage zum Viewport, nicht die Sichtbarkeit: er würde
     die Bilder sofort trotzdem laden. Auf dem DESKTOP bringt lazy hier
     also fast nichts.
     Warum lazy trotzdem gesetzt wird:
     Unter 1100px ist .ft-catnav komplett display:none — dort verhindert
     lazy den Download vollständig. Genau die 22 Bilder, die auf dem Handy
     nie jemand sieht (dort führt der Hamburger-Drawer), verschwinden damit
     aus dem mobilen Ladepfad.

     Deshalb zusätzlich diese Stufe für den Desktop: die echte Bild-URL
     steht in data-ft-mega-src, im src steht ein 1x1-Platzhalter. Getauscht
     wird
       a) beim ersten Hover-/Fokus-/Tap-Intent auf der Navi-LEISTE — also
          beim Betreten von .ft-catnav, nicht erst am einzelnen Trigger, und
       b) spätestens in der ersten Leerlaufzeit nach dem load-Event
          (requestIdleCallback, timeout 2500ms; Fallback setTimeout 1200ms).
     TRAGENDE STUFE IST b): sie greift im Normalfall lange vor dem ersten
     Hover, die Bilder liegen dann im Cache und das Panel ist beim Aufklappen
     sofort vollständig. a) ist nur die Notreserve für den Fall, dass jemand
     sofort nach dem Laden hovert — der Vorlauf ist dort KNAPP: das Panel
     öffnet ohne Verzögerung, fair-turbo.css blendet es in .08s ein (die
     .28s Verzögerung dort gilt nur fürs SCHLIESSEN). Es bleiben also nur
     Zeigerweg + ~80ms. Wer diese Stufe anfasst: b) niemals entschärfen. */
  var FT_MEGA_PX = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
  var ftMegaQueue = [];
  var ftMegaWarmed = false;
  /* Anzeigegröße an die Asset-URL hängen (dieselbe Form, die image_url
     erzeugt). Kennt der CDN den Parameter nicht, liefert er das Original —
     schlimmstenfalls also der bisherige Zustand, nie ein kaputtes Bild. */
  function ftImgW(url, w) {
    if (!url || /[?&]width=/.test(url)) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function ftMegaSwap(img) {
    var s = img.getAttribute('data-ft-mega-src');
    if (!s) return;
    img.removeAttribute('data-ft-mega-src');
    img.setAttribute('src', s);
  }
  function ftMegaDefer(img, src) {
    if (!img || !src) return;
    img.setAttribute('data-ft-mega-src', src);
    img.removeAttribute('srcset');
    img.setAttribute('loading', 'lazy');
    img.setAttribute('decoding', 'async');
    img.setAttribute('fetchpriority', 'low');
    if (ftMegaWarmed) { ftMegaSwap(img); return; }
    img.setAttribute('src', FT_MEGA_PX);
    ftMegaQueue.push(img);
  }
  function ftMegaWarm() {
    if (ftMegaWarmed) return;
    ftMegaWarmed = true;
    var q = ftMegaQueue;
    ftMegaQueue = [];
    q.forEach(ftMegaSwap);
  }
  var ftCatnavBar = document.querySelector('.ft-catnav');
  if (ftCatnavBar) {
    ['pointerenter', 'pointerdown', 'focusin'].forEach(function(evt) {
      ftCatnavBar.addEventListener(evt, ftMegaWarm, { once: true, passive: true });
    });
  }
  function ftMegaWarmIdle() {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(ftMegaWarm, { timeout: 2500 });
    } else {
      setTimeout(ftMegaWarm, 1200);
    }
  }
  if (document.readyState === 'complete') {
    ftMegaWarmIdle();
  } else {
    window.addEventListener('load', ftMegaWarmIdle, { once: true });
  }

  /* ── Mega-Menü-Bildkachel (22.07.) ──────────────────────
     Kuratierte Kategorie-Bilder rechts im Panel. Injektion per JS statt
     Liquid, damit Brand-Default-Nav (Snippet ft-brand-nav) und
     Shopify-Menü dieselbe Kachel bekommen — die Panels sind beim
     Seitenaufbau unsichtbar, die Kachel steht also, bevor jemand hovert.
     Key = Collection-Handle aus dem Trigger-Link. */
  var ftCatImg = (window.ftKopfBilder && window.ftKopfBilder.kat) || {};
  catnavItems.forEach(function(item) {
    var link = ftMegaLink(item);
    var inner = item.querySelector('.ft-mega-panel .ft-mega-inner');
    if (!link || !inner) return;
    if (inner.querySelector('.ft-mega-auto')) return; /* Auto-Panel: eigenes Layout */
    if (inner.classList.contains('ft-mm')) return; /* 15.10.2026 abends: neues Menü mit Fahrzeug und Hilfe statt Bildkachel */
    var href = link.getAttribute('href') || '';
    var match = href.match(/\/collections\/([a-z0-9-]+)/);
    var imgSrc = match && ftCatImg[match[1]];
    if (!imgSrc) return;
    var label = (link.textContent || '').replace(/\s+/g, ' ').trim();
    var tile = document.createElement('a');
    tile.className = 'ft-mega-feature';
    tile.href = href;
    /* 24.07.: kein src im Markup — die URL wandert über ftMegaDefer in
       data-ft-mega-src und wird beim Hover-Intent bzw. im Leerlauf nach dem
       load-Event gesetzt (Begründung ganz oben). Größe: die Feature-Spalte
       ist 232px breit, das Bild zeichnet darin ~198px (CSS: 16px Innenrand
       je Seite) bei fester Höhe 164px — 400px deckt damit 2x/Retina.
       Lazy-0x0 geprüft: .ft-mega-feature-img hat height:164px im CSS. */
    tile.innerHTML =
      '<img class="ft-mega-feature-img" alt="' + escapeHtml(label) + '" width="800" height="597" loading="lazy" decoding="async" fetchpriority="low">' +
      '<span class="ft-mega-feature-body">' +
        '<span class="ft-mega-feature-name">' + escapeHtml(label) + '</span>' +
        '<span class="ft-mega-feature-cta">Alle ansehen <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg></span>' +
      '</span>';
    inner.appendChild(tile);
    inner.classList.add('ft-mega-has-feature');
    ftMegaDefer(tile.querySelector('.ft-mega-feature-img'), ftImgW(imgSrc, 400));
  });

  /* ── Nav-Icons: stehen seit 05.10.2026 weiter inline in sections/ft-header.liquid, weil sie vor dem ersten Bild
     laufen müssen (sonst springen die Menüpunkte am PC nach). */

  /* ── Mega-Menü-Kuration (22.07., Pascal) ─────────────────────
     Das Brand-Nav-Snippet (ft-mega-tile) rendert noch gelbe
     "↩ Pfand"-Pillen und ggf. Collection-Bilder — diese Runde darf
     nur ft-header.liquid anfassen, deshalb Korrektur hier per JS
     (Panels sind beim Seitenaufbau unsichtbar, läuft vor dem ersten
     Hover). Der Shopify-Menü-Pfad oben ist bereits in Liquid sauber.

     a) Pillen-Ersatz: ruhige Textnotiz "inkl. Altteilpfand" unter
        der Beschreibung (CSS blendet die Pille zusätzlich aus).
     b) Thumbnails (v4, 23.07.): Kette kuratiertes Studio-Asset
        (ft-cat-*.jpg) → Collection-Bild aus dem Snippet →
        Fallback-Map ftTileShopImg (Collection-/Produktbild) →
        sonst gar kein Bild (kein leeres Icon).
        24.07.: NICHT mehr eager — jedes dieser Bilder läuft über
        ftMegaDefer (Platzhalter + Vorladen im Leerlauf, Begründung
        oben). Feste Maße bleiben Pflicht: die Höhe kommt aus dem
        CSS (.ft-mega-tile-icon 58×44 bzw. 76×58 in fair-turbo.css),
        zusätzlich stehen width/height-Attribute — ohne die kollabiert
        ein lazy-Bild auf 0 und wird nie geladen. */
  document.querySelectorAll('.ft-mega-panel .ft-pill-warn').forEach(function(pill) {
    var pTile = pill.closest('.ft-mega-tile');
    pill.parentNode.removeChild(pill);
    if (!pTile) return;
    var body = pTile.querySelector('.ft-mega-tile-body');
    if (!body || body.querySelector('.ft-mega-tile-pfand')) return;
    var note = document.createElement('div');
    note.className = 'ft-mega-tile-pfand';
    note.textContent = 'inkl. Altteilpfand';
    var count = body.querySelector('.ft-mega-tile-count');
    if (count) { body.insertBefore(note, count); } else { body.appendChild(note); }
  });

  var ftTileImg = (window.ftKopfBilder && window.ftKopfBilder.kachel) || {};
  /* v4 (23.07., Pascal: "fehlen noch Produktbilder"): Fallback-Bilder
     für Brand-Nav-Handles OHNE kuratiertes Studio-Asset — Kette wie im
     Shopify-Menü-Pfad oben: Collection-Bild → erstes Produktbild.
     Die Handle-Liste spiegelt snippets/ft-brand-nav.liquid (Snippet
     diese Runde tabu, daher Map hier). Bilder in Shopify stammen aus
     der bereit-Pipeline (FT-Branding) — Leak-Sperre vom 22.07. damit
     aufgehoben. Ohne jedes Bild bleibt der Eintrag bildlos. */
  var ftTileShopImg = (window.ftKopfBilder && window.ftKopfBilder.shop) || {};
  document.querySelectorAll('.ft-mega-panel .ft-mega-tile').forEach(function(tile) {
    var m = (tile.getAttribute('href') || '').match(/\/collections\/([a-z0-9-]+)/);
    var curated = m && ftTileImg[m[1]];
    var photoBox = tile.querySelector('.ft-mega-tile-icon.ft-has-photo');
    var photo = photoBox ? photoBox.querySelector('.ft-mega-photo') : null;
    /* 24.07.: Studio-Asset in Kachelgröße statt 800px Naturbreite —
       angezeigt werden ~50x36 (Kachel 58x44 minus 4px Innenabstand),
       160px deckt auch 3x-Displays. */
    var src = curated ? ftImgW(curated, 160) : null;
    if (!curated) {
      if (photo) {
        /* v4 (23.07.): Collection-Bild aus dem Snippet bleibt stehen
           (bereit-Pipeline, siehe Map-Kommentar oben).
           24.07.: NICHT mehr eager erzwingen — das Bild kommt jetzt über
           dieselbe Vorlade-Stufe wie alle anderen Menübilder. Die Kachel
           hat feste 58x44 im CSS, die 0x0-Falle greift also nicht. */
        ftMegaDefer(photo, photo.getAttribute('src'));
        return;
      }
      src = m ? ftTileShopImg[m[1]] : null;
      if (!src) {
        /* Gar kein Bild verfügbar → kein leeres Icon stehen lassen (v4) */
        var bareIcon = tile.querySelector('.ft-mega-tile-icon');
        if (bareIcon) bareIcon.parentNode.removeChild(bareIcon);
        return;
      }
    }
    /* Hintergrund-Illustration (v2) hinter Foto-Kacheln wäre Doppel-Deko */
    var illu = tile.querySelector('.ft-mega-tile-illu');
    if (illu) illu.parentNode.removeChild(illu);
    if (photo) {
      photo.setAttribute('width', '800');
      photo.setAttribute('height', '597');
      ftMegaDefer(photo, src);
    } else {
      var titleEl = tile.querySelector('.ft-mega-tile-title');
      var tLabel = titleEl ? (titleEl.textContent || '').replace(/\s+/g, ' ').trim() : '';
      var box = document.createElement('div');
      box.className = 'ft-mega-tile-icon ft-has-photo';
      var img = document.createElement('img');
      img.className = 'ft-mega-photo';
      img.setAttribute('width', '800');
      img.setAttribute('height', '597');
      img.alt = tLabel;
      ftMegaDefer(img, src);
      box.appendChild(img);
      var iconBox = tile.querySelector('.ft-mega-tile-icon');
      if (iconBox) { tile.replaceChild(box, iconBox); }
      else { tile.insertBefore(box, tile.firstChild); }
    }
  });
})();

/* 08.10.2026 (Sitzung Webshop, Pascal: „den uvp natürlich überall anzeigen wo das produkt mit preis zu sehen ist“): UVP des Herstellers an
   Stellen, deren Preis per Skript kommt (Suchvorschläge, Merkliste, Schnellansicht, Fenster nach dem Einlegen, Vergleich, Motor-Tabellen).
   Dort steht vor dem Preis ein Platzhalter <span class="ft-uvp-platz" data-ft-uvp="handle"></span>. Dieser Helfer lädt je Produkt einmal
   /products/<handle>?view=ft-uvp (templates/product.ft-uvp.liquid, die Zeile aus snippets/ft-uvp mit allen Regeln) und setzt sie ein.
   Leere Antwort heißt keine UVP, der Platzhalter bleibt leer und unsichtbar. Datei wird auf jeder Seite geladen (sections/ft-header). */
(function () {
  if (window.ftUvpFuellen) return;
  var cache = {};
  function laden(h) {
    if (!cache[h]) {
      cache[h] = fetch('/products/' + encodeURIComponent(h) + '?view=ft-uvp', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) {
          t = String(t || '').trim();
          // Nur die kurze Zeile aus ft-uvp annehmen. Fehlt die Vorlage, liefert Shopify die ganze Produktseite (mit eigener UVP-Zeile),
          // die darf nie in einen Vorschlag gelangen.
          if (t.length > 600 || !/^<(p|span)\b[^>]*class="ft-uvp\b/.test(t)) return '';
          return t.replace(/<p\b/g, '<span').replace(/<\/p>/g, '</span>');
        })
        .catch(function () { return ''; });
    }
    return cache[h];
  }
  function fuellen(wurzel) {
    var platz = (wurzel && wurzel.querySelectorAll ? wurzel : document).querySelectorAll('[data-ft-uvp]:not([data-ft-uvp-fertig])');
    Array.prototype.forEach.call(platz, function (el) {
      var h = el.getAttribute('data-ft-uvp');
      el.setAttribute('data-ft-uvp-fertig', '');
      if (!h) return;
      laden(h).then(function (html) { if (html) el.innerHTML = html; });
    });
  }
  window.ftUvpHandle = function (url) {
    var m = String(url || '').match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  };
  window.ftUvpPlatz = function (h) {
    return h ? '<span class="ft-uvp-platz" data-ft-uvp="' + String(h).replace(/[^a-z0-9\-_.]/gi, '') + '"></span>' : '';
  };
  window.ftUvpFuellen = fuellen;
  var st = document.createElement('style');
  st.textContent = '.ft-uvp-platz:empty{display:none}.ft-uvp-platz{display:block}' +
    '.ft-uvp-platz .ft-uvp{display:block;margin:0 0 2px;font-size:13px;font-weight:600;line-height:1.35;color:#C62828;font-variant-numeric:tabular-nums}' +
    '.ft-uvp-platz .ft-uvp-betrag{white-space:nowrap}' +
    '.ft-uvp-platz .ft-uvp--b .ft-uvp-betrag{text-decoration:line-through;text-decoration-thickness:1.5px;text-decoration-color:#C62828}';
  document.head.appendChild(st);
  var geplant = 0;
  new MutationObserver(function (liste) {
    for (var i = 0; i < liste.length; i++) {
      var neu = liste[i].addedNodes;
      for (var j = 0; j < neu.length; j++) {
        var n = neu[j];
        if (n.nodeType === 1 && (n.hasAttribute('data-ft-uvp') || n.querySelector('[data-ft-uvp]'))) {
          if (!geplant) geplant = setTimeout(function () { geplant = 0; fuellen(document); }, 30);
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  fuellen(document);
})();

/* 08.10.2026 (Sitzung Webshop, Bedienbarkeit Punkt 2): Ratgeber-Tabellen am Handy als Karten (CSS in assets/fair-turbo.css,
   Klasse ft-tab-karten). Jede Zelle bekommt den Namen ihrer Spalte als data-label. Nur Tabellen mit Überschriften (thead oder
   erste Zeile aus th); ohne Überschriften bleibt die Tabelle, wie sie ist. */
(function () {
  function tabellen() {
    var alle = document.querySelectorAll('.ft-article-body table');
    for (var t = 0; t < alle.length; t++) {
      var tab = alle[t];
      var kopfZeile = tab.querySelector('thead tr');
      if (!kopfZeile) {
        var erste = tab.querySelector('tr');
        if (erste && erste.querySelector('th') && !erste.querySelector('td')) { kopfZeile = erste; erste.classList.add('ft-tab-kopf'); }
      }
      if (!kopfZeile) continue;
      var namen = [];
      for (var k = 0; k < kopfZeile.children.length; k++) namen.push(kopfZeile.children[k].textContent.replace(/\s+/g, ' ').trim());
      if (namen.length < 2) continue;
      var zeilen = tab.querySelectorAll('tr');
      for (var z = 0; z < zeilen.length; z++) {
        if (zeilen[z] === kopfZeile) continue;
        for (var s = 0; s < zeilen[z].children.length; s++) {
          var zelle = zeilen[z].children[s];
          if (namen[s]) zelle.setAttribute('data-label', namen[s]);
        }
      }
      tab.classList.add('ft-tab-karten');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tabellen); else tabellen();
})();
